// Decide whether silent video autoplay is appropriate for this visitor.
// Respects the OS "reduce motion" setting (accessibility) and Data Saver /
// slow networks so mobile users on data aren't caught out. Unknown → allow.
export function shouldAutoplayVideo() {
  try {
    if (typeof window !== "undefined" && window.matchMedia
        && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return false;
    }
    const c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return true;
    if (c.saveData) return false;
    const et = c.effectiveType || "";
    if (et === "slow-2g" || et === "2g") return false;
    return true;
  } catch {
    return true;
  }
}
